/**
 * アプリのマーク。画像は public/icons/mark.svg 一枚（scripts/gen_icons.py が
 * favicon・PWAアイコンと同じ定義から書き出す）。ここで SVG を書き写すと
 * アイコンと画面内で絵が食い違うので、必ず同じファイルを参照する。
 */
export default function BrandMark({ size = 24, style }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/icons/mark.svg`}
      alt=""
      width={size}
      height={size}
      draggable={false}
      style={{ display: 'block', borderRadius: size * 0.22, flexShrink: 0, ...style }}
    />
  );
}
